<form class="p-fluid grid formgrid p-1" #textForm="ngForm">
	<ng-container>
		<!-- Référence -->
		<div class="field col-12 md:col-6 xl:col-4">
			<label for="txt_reference">
				{{ 'textes.reference_label' | translate }}
			</label>

			<input
				type="text"
				pInputText
				name="txt_reference"
				[(ngModel)]="texte.txt_reference"
				[readonly]="true"
				placeholder="{{'textes.reference_label' | translate}}"
				required
			>
		</div>

		<!-- Edition -->
		<div class="field col-12 md:col-6 xl:col-4">
			<label for="txt_edition">
				{{ 'textes.edition_label' | translate }}
			</label>

			<input
				type="text"
				pInputText
				name="txt_edition"
				[(ngModel)]="texte.txt_edition"
				[readonly]="true"
				placeholder="{{'textes.edition_label' | translate}}"
			>
		</div>

		<div class="col-12"></div>

		<!-- URL -->
		<div class="field col-12 mb-3">
			<label for="txt_url">
				{{ 'textes.link_label' | translate }}
			</label>

			<a href="{{texte.txt_url}}" class="text-blue-500">
				{{texte.txt_url}}
			</a>
		</div>

		<!-- Rubriques -->
		<div class="field col-12 mb-4">
			<label for="txt_edition">
				{{ 'textes.rubriques_label' | translate }}
			</label>

			<div class="rubriques-list expanded mb-2">

				<!-- Rubriques -->
				<p-card *ngFor="let rubrique of texte.rubriques">
					<div class="flex flex-row align-items-center justify-content-between">
						<span>{{rubrique|nomenclature}}</span>
					</div>
				</p-card>

				<!-- Message si aucune rubrique -->
				<div *ngIf="texte.rubriques.length == 0">
					{{
						(texte.txt_exclusivement_modificatif ? 
						'textes.rubrique_restriction_explanation'
						: 'textes.texte_linked_to_no_rubrique') | translate
					}}
				</div>
			</div>
		</div>

		<div class="col-12"></div>

		<!-- Date signature -->
		<div class="field col-12 md:col-6 xl:col-3">
			<label for="txt_date_signature">
				{{ 'textes.signature_date_label' | translate }}
			</label>

			<input
				[ngClass]="{inactive: !texte.txt_date_signature}"
				type="text"
				pInputText
				[attr.value]="texte.txt_date_signature | date:'shortDate'"
				[readonly]="true"
			>
		</div>

		<div class="col-12"></div>

		<!-- Date abrogation -->
		<div class="field col-12 md:col-6 xl:col-3">
			<label for="txt_date_abrogation">
				{{ 'textes.abrogation_date_label' | translate }}
			</label>

			<input
				[ngClass]="{inactive: !texte.txt_date_abrogation}"
				type="text"
				pInputText
				[attr.value]="texte.txt_date_abrogation | date:'shortDate'"
				[readonly]="true"
			>
		</div>

		<!-- Abrogation (booléen) -->
		<div class="field field-checkbox col-fixed">
			<!-- Si la case n'est pas cochée et qu'il y a une date dans le futur on empêche de cocher -->
			<p-checkbox
				name="txt_abrogation"
				[(ngModel)]="texte.txt_abrogation"
				[binary]="true"
				[readonly]="true"
				[disabled]="true"
				[label]="'textes.abrogation_label' | translate"
			></p-checkbox>
		</div>

		<div class="col-12"></div>

		<!-- Date application -->
		<div class="field col-12 md:col-6 xl:col-3">
			<label for="txt_date_application">
				{{ 'textes.application_date_label' | translate }}
			</label>

			<input
				[ngClass]="{inactive: !texte.txt_date_application}"
				type="text"
				pInputText
				[attr.value]="texte.txt_date_application | date:'shortDate'"
				[readonly]="true"
			>
		</div>

		<!-- Note d'applicaion -->
		<div class="field col-12 md:col-6 xl:col-3">
			<label for="txt_application">
				{{ 'textes.application_note_label' | translate }}
			</label>

			<input
				type="text"
				pInputText
				name="txt_application"
				[(ngModel)]="texte.txt_application"
				[readonly]="true"
				placeholder="{{'textes.application_note_label' | translate}}"
			>
		</div>

		<div class="col-12"></div>

		<!-- Date modificative -->
		<div class="field col-12 md:col-6 xl:col-3">
			<label for="txt_date_modificative">
				{{ 'textes.modification_date_label' | translate }}
			</label>

			<input
				[ngClass]="{inactive: !texte.txt_date_modificative}"
				type="text"
				pInputText
				[attr.value]="texte.txt_date_modificative | date:'shortDate'"
				[readonly]="true"
			>
		</div>

		<!-- Note sur la modification -->
		<div class="field col-12 md:col-6 xl:col-3">
			<label for="txt_modification">
				{{ 'textes.modification_note_label' | translate }}
			</label>

			<input
				type="text"
				pInputText
				name="txt_modification"
				[(ngModel)]="texte.txt_modification"
				[readonly]="true"
				placeholder="{{'textes.modification_note_label' | translate}}"
			>
		</div>

		<div class="col-12"></div>

		<!-- Exclusivement modificatif (booléen) -->
		<div class="field field-checkbox col-fixed">
			<p-checkbox
				name="txt_exclusivement_modificatif"
				[(ngModel)]="texte.txt_exclusivement_modificatif"
				[binary]="true"
				[readonly]="true"
				[disabled]="true"
				[label]="'textes.exclusivement_modificatif_label' | translate"
			></p-checkbox>
		</div>

		<div class="col-12"></div>

		<!-- Intitulé (HTML) -->
		<div class="field col-12">
			<label for="txt_intitule" class="font-bold">
				{{ 'textes.intitule' | translate }}
			</label>

			<div class="w-full">
				<html-editor
					name="txt_intitule"
					class="no-padding-html-view no-border-html-view"
					[(ngModel)]="texte.txt_intitule"
					[readonly]="true"
					class="mt-1"
				></html-editor>
			</div>
		</div>

		<!-- Commentaire (HTML) -->
		<div class="field col-12">
			<label for="txt_commentaire" class="font-bold">
				{{ 'textes.commentaire_label' | translate }}
			</label>
			<div class="w-full">
				<html-editor
					name="txt_commentaire"
					class="no-padding-html-view no-border-html-view"
					[(ngModel)]="texte.txt_commentaire"
					[readonly]="true"
					class="mt-1"
				></html-editor>
			</div>
		</div>
	</ng-container>

	<!-- Section des articles -->
	<p-divider class="col-12" align="center">
		<b>{{'textes.articles_section_label' | translate}}<span *ngIf="texte.articles.length">({{texte.articles.length}})</span></b>
	</p-divider>

	<!-- Recherche -->
	<div *ngIf="texte.articles.length" class="field col-fixed">
		<label for="search">{{'common.search_label'|translate}}</label>
		<div class="p-inputgroup mr-2">
			<input
				pInputText
				type="text"
				name="search"
				[(ngModel)]="search"
				(onDebounce)="onArticleSearchChange()"
				placeholder="{{'common.search_input_placeholder' | translate}}"
			/>
			<button type="button" class="p-inputgroup-addon" icon="pi pi-times" pButton label="" [disabled]="!search" (click)="search = null" ></button>
		</div>
	</div>

	<!-- Articles -->
	<div #articleScroller class="w-full">
		<p-table
			#dataViewArticles
			[value]="articles"
			[paginator]="true"
			paginatorPosition="top"
			[showCurrentPageReport]="true"
			[totalRecords]="articles.length"
			currentPageReportTemplate="{{articles.length | number}} élément(s)"
			[rows]="initialRowsPerPage"
			(rows)="currentRowsPerPage"
			[rowsPerPageOptions]="[5,10,25,50]"
			[scrollable]="true"
			responsiveLayout="scroll"
			scrollHeight="300"
			class="article-table"
		>
			<ng-template pTemplate="body" let-article let-index="rowIndex">
				<!-- Séparateur entre chaque article -->
				<div
					class="block col-12 mt-2 mb-2 flex flex-row align-items-center"
				>
					<div class="border-top-1 border-gray-100 flex-grow-1"></div>
				</div>

				<!-- Header (absent en mode lecture si titre vide) -->
				<div class="flex flex-row align-items-center w-full p-2 surface-ground border-round">
					<!-- Titre -->
					<div class="flex-grow-1 flex align-items-center">
						<span class="text-sm flex-shrink-0 mr-2">#{{article.art_ordre +1}}</span>
						<span class="font-bold">
							{{article.art_titre}}
						</span>
					</div>

					<div class="flex flex-row align-items-center mr-2">
						<!-- Abrogation article -->
						<div class="mb-0 ml-3">
							<!-- Si la case n'est pas cochée et qu'il y a une date dans le futur on empêche de cocher -->
							<p-checkbox
								name="article-abrogation{{article.art_id}}"
								[(ngModel)]="article.art_abrogation"
								[binary]="true"
								label="{{'textes.abrogation_label' | translate}}"
								[readonly]="true"
								[disabled]="true"
							></p-checkbox>
						</div>

						<div class="ml-2 mr-2" *ngIf="article.art_abrogation">
							<!-- Date d'abrogation de l'article -->
							<input
								class="surface-ground w-12rem"
								[ngClass]="{inactive: !article.art_date_abrogation}"
								type="text"
								pInputText
								[attr.value]="article.art_date_abrogation | date:'shortDate'"
								[readonly]="true"
							>
						</div>

						<!-- Article modificatif -->
						<div class="mb-0 ml-3">
							<p-checkbox
								name="article-modificatif{{article.art_id}}"
								[(ngModel)]="article.art_modificatif"
								[binary]="true"
								label="{{'textes.modificative' | translate}}"
								[disabled]="true"
							></p-checkbox>
						</div>
					</div>

					<!-- Boutons sur la droite -->
					<div class="flex flex-row">

						<!-- Réduction -->
						<button
							type="button"
							pButton
							icon="p-button-icon-left pi {{ expandedArticles[article.art_id]? 'pi-arrow-down-left-and-arrow-up-right-to-center' : 'pi-arrow-up-right-and-arrow-down-left-from-center' }}"
							class="p-button-rounded p-button-text"
							(click)="expandedArticles[article.art_id] = !!!expandedArticles[article.art_id]"
							[title]="(expandedArticles[article.art_id]? 'common.collapse': 'common.expand') | translate"
						>
						</button>
					</div>

				</div>

				<!-- Corps HTML -->
				<div class="html-content article-body w-full" 
					[ngClass]="{expanded: expandedArticles[article.art_id]}"
					(click)="expandedArticles[article.art_id] = true"
					[innerHTML]="article.art_corps">
				</div>

			</ng-template>
		</p-table>
	</div>
</form>
